import { Types } from '@store/types';

export const toggleMyColleaguesFilter = (data) => (dispatch) => {
	dispatch({
		type: Types.TOGGLE_MY_COLLEAGUES_FILTER,
		payload: data
	});
};

export const storeMyColleaguesSearchKey = (data) => (dispatch) => {
	dispatch({
		type: Types.STORE_MY_COLLEAGUES_SEARCH_KEY,
		payload: data
	});
};

export const showMyColleaguesDetailsPage = (data) => (dispatch) => {
	dispatch({
		type: Types.SHOW_MY_COLLEAGUES_DETAILS_PAGE,
		payload: data
	});
};
